export default function preloaderGame11 (scene) {

    scene.load.image(`tilesgame11`, `/tiles/game11.png`);

	scene.load.audio("becauseSong", ["/audio/songs/11-because.mp3"]);

	scene.load.spritesheet(`jiu-game11`, 
		`/img/game11/jiu.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game11`, 
		`/img/game11/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game11`, 
		`/img/game11/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game11`, 
		`/img/game11/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game11`, 
		`/img/game11/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game11`, 
		`/img/game11/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game11`,
		`/img/game11/gahyeon.png`,
		{ frameWidth: 27, frameHeight: 37}
	);	
	
	scene.load.spritesheet(`jiu2-game11`, 
		`/img/game11/negative/jiu.png`,
		{ frameWidth: 27, frameHeight: 37}
	);

	scene.load.spritesheet(`sua2-game11`, 
		`/img/game11/negative/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon2-game11`, 
		`/img/game11/negative/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong2-game11`, 
		`/img/game11/negative/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon2-game11`, 
		`/img/game11/negative/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami2-game11`, 
		`/img/game11/negative/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon2-game11`,
		`/img/game11/negative/gahyeon.png`,
		{ frameWidth: 27, frameHeight: 37}
	);	

	
	scene.load.spritesheet(`humo-game11`, 
		`/img/generalSprites/humo-big.png`,
		{ frameWidth: 41, frameHeight: 42}
	);
 
	scene.load.tilemapTiledJSON(`game11`, `/tiles/game11.tmj`);

}